// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPropertyChangeDto
 */
export interface IPropertyChangeDto {
    /**
     * 
     * @type {string}
     * @memberof IPropertyChangeDto
     */
    property_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyChangeDto
     */
    old_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyChangeDto
     */
    new_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyChangeDto
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyChangeDto
     */
    group_type?: IPropertyChangeDtoGroupTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPropertyChangeDtoGroupTypeEnum {
    MULTI_FACTOR_AUTHENTICATION = 'MULTI_FACTOR_AUTHENTICATION',
    STATEMENTS = 'STATEMENTS',
    PAPER_STATEMENTS_FEES = 'PAPER_STATEMENTS_FEES',
    PAYROLL_CONTRIBUTION_PULL = 'PAYROLL_CONTRIBUTION_PULL',
    PAYROLL_CONTRIBUTION_PUSH = 'PAYROLL_CONTRIBUTION_PUSH',
    PRE_FUND = 'PRE_FUND',
    REIMBURSEMENT_OPTIONS = 'REIMBURSEMENT_OPTIONS',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    AI_ADJUDICATION = 'AI_ADJUDICATION',
    ORPHAN_CONFIGURATION = 'ORPHAN_CONFIGURATION',
    CARDS = 'CARDS',
    FILE_MANAGER = 'FILE_MANAGER',
    DOCUMENTS_NEEDED_REMINDER = 'DOCUMENTS_NEEDED_REMINDER',
    SUSPEND_CARD = 'SUSPEND_CARD',
    SUSPENSION_THRESHOLD = 'SUSPENSION_THRESHOLD',
    BALANCE_ADJUSTMENT_PULL = 'BALANCE_ADJUSTMENT_PULL',
    BALANCE_ADJUSTMENT_PUSH = 'BALANCE_ADJUSTMENT_PUSH',
    FRAUD_THRESHOLD = 'FRAUD_THRESHOLD',
    FRAUD_SINGLE = 'FRAUD_SINGLE',
    FRAUD_DAILY = 'FRAUD_DAILY',
    FRAUD_WEEKLY = 'FRAUD_WEEKLY',
    PP_CHATBOT = 'PP_CHATBOT'
}


/**
 * Check if a given object implements the IPropertyChangeDto interface.
 */
export function instanceOfIPropertyChangeDto(value: object): value is IPropertyChangeDto {
    return true;
}

export function IPropertyChangeDtoFromJSON(json: any): IPropertyChangeDto {
    return IPropertyChangeDtoFromJSONTyped(json, false);
}

export function IPropertyChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPropertyChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'property_name': json['property_name'] == null ? undefined : json['property_name'],
        'old_value': json['old_value'] == null ? undefined : json['old_value'],
        'new_value': json['new_value'] == null ? undefined : json['new_value'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
    };
}

export function IPropertyChangeDtoToJSON(json: any): IPropertyChangeDto {
    return IPropertyChangeDtoToJSONTyped(json, false);
}

export function IPropertyChangeDtoToJSONTyped(value?: IPropertyChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_name': value['property_name'],
        'old_value': value['old_value'],
        'new_value': value['new_value'],
        'display_name': value['display_name'],
        'group_type': value['group_type'],
    };
}

